import { UseFormRegisterReturn } from 'react-hook-form';
import { InterestRadioButton } from './interest-radio-button';
import { Typography } from '@/components';
import { t } from 'i18next';

interface RolesSectionProps {
  roles: { value: string; label: string }[];
  registration: UseFormRegisterReturn;
  selectedRoles: string[];
  isCompanyForm?: boolean;
}

export function RolesSection({ roles, registration, selectedRoles, isCompanyForm }: RolesSectionProps) {
  return (
    <div className="space-y-2">
      {isCompanyForm ? (
        <div className="space-y-0.5 mb-4">
          <Typography as="h4" color="primary" size="body-1" weight="semibold">
            {t('Activity')}
          </Typography>
        </div>
      ) : (
        <div className="space-y-0.5">
          <Typography as="h6" color="primary" size="body-1" weight="semibold">
            {t('What roles describes you best?')}
          </Typography>
          <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1">
            {t('You can select more than one option')}
          </Typography>
        </div>
      )}
      <div className="flex flex-wrap justify-left gap-2 md:justify-start">
        {roles.map(({ label, value }) => (
          <InterestRadioButton
            key={value}
            id={`role-${value}`}
            value={value}
            registration={registration}
            isSelected={selectedRoles.includes(value)}
          >
            <span>{label}</span>
          </InterestRadioButton>
        ))}
      </div>
    </div>
  );
}
